import { RootState } from "@/store/store";
import { resourceDetailsTargetResourceSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceSelector";

export const k8SResourceDetailsTargetNoUsageSelector = (state: RootState) => {
  const resource = resourceDetailsTargetResourceSelector(state);
  const k8sData = resource?.providerMetadata?.k8s;

  return !!k8sData && !k8sData?.usage;
};
